import ENDPOINT from "@/api/endpoints";
import {
  callApiGetLoaiLichLamViec,
  callApiGetDanhSanhLichLamViec,
  callApisuaLichLamViec,
  callApiXoaLichLamViec,
  callApiLayDanhSachTheoLoaiLichCha,
  callApiGetChiTietLoaiLichLamViec
} from "@/api/lich-lam-viec";

const layDanhSachLoaiLichLamViec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetLoaiLichLamViec(payload)
      .then(response => {
        if (response) {
          context.commit(
            "SET_DANH_SACH_LOAI_LICH_LAM_VIEC",
            response.data.data
          );
        }
        resolve(response);
      })
      .catch(error => {
        console.error(error);
        reject(error);
      });
  });
};

const layChiTietLoaiLichLamViec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetChiTietLoaiLichLamViec(payload)
      .then(response => {
        if (response) {
          context.commit(
            "LAY_CHI_TIET_LOAI_LICH_THANH_CONG",
            response.data.data
          );
        }
        resolve(response.data.data);
      })
      .catch(error => {
        console.error(error);
        reject(error);
      });
  });
};

const layDanhSachLichLamViec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDanhSanhLichLamViec(payload)
      .then(response => {
        if (response) {
          context.commit(
            "SET_DANH_SACH_LICH_LAM_VIEC",
            response.data.data.items
          );
        }
        resolve(response);
      })
      .catch(error => {
        console.error(error);
        reject(error);
      });
  });
};

const suaLichLamviec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApisuaLichLamViec(payload, ENDPOINT.LICH_LAM_VIEC.SUA_LICH_LAM_VIEC)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error(error);
        reject(error);
      });
  });
};

const xoaLichLamViec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaLichLamViec(payload, ENDPOINT.LICH_LAM_VIEC.XOA_LICH_LAM_VIEC)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.error(error);
        reject(error);
      });
  });
};

const layDanhSachTheoLoaiLichCha = async ({ commit }, payload) => {
  const response = await callApiLayDanhSachTheoLoaiLichCha(payload);
  if (response && response.data.succeeded) {
    commit("LAY_DANH_SACH_THEO_LOAI_LICH_CHA_THANH_CONG", response.data.data);
    return response.data.data;
  }
};
export default {
  layDanhSachLoaiLichLamViec,
  layDanhSachLichLamViec,
  suaLichLamviec,
  xoaLichLamViec,
  layDanhSachTheoLoaiLichCha,
  layChiTietLoaiLichLamViec
};
